import Stores from 'components/Pages/Stores/Stores';

export default Stores;
